module.exports = __webpack_public_path__ + "static/media/path.36963e72.svg";